/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SharedProjectDto } from './sharedProjectDto';

export interface CheckRule { 
    id?: string;
    name?: string;
    description?: string;
    category?: CheckRule.CategoryEnum;
    projectId?: number;
    ruleData?: string;
    ruleDataFormat?: string;
    active?: boolean;
    configJson?: string;
    status?: CheckRule.StatusEnum;
    version?: number;
    publishedId?: string;
    createdAt?: Date;
    updatedAt?: Date;
    sharedProjects?: Array<SharedProjectDto>;
}
export namespace CheckRule {
    export type CategoryEnum = 'IDS' | 'LOI' | 'HOAI' | 'QUALITY' | 'CUSTOM';
    export const CategoryEnum = {
        IDS: 'IDS' as CategoryEnum,
        LOI: 'LOI' as CategoryEnum,
        HOAI: 'HOAI' as CategoryEnum,
        QUALITY: 'QUALITY' as CategoryEnum,
        CUSTOM: 'CUSTOM' as CategoryEnum
    };
    export type StatusEnum = 'DRAFT' | 'PUBLISHED' | 'ARCHIVED';
    export const StatusEnum = {
        DRAFT: 'DRAFT' as StatusEnum,
        PUBLISHED: 'PUBLISHED' as StatusEnum,
        ARCHIVED: 'ARCHIVED' as StatusEnum
    };
}